import PropTypes from 'prop-types';
const themePropType = PropTypes.object;
export default themePropType;